import { all, fork, put, takeEvery, call } from "redux-saga/effects";

import {
    getStalls,
    getStallById,
    createStall,
    updateStall,
    deleteStall,
} from "helpers/api/stalls";

import { StallActionTypes } from "./constants";
import {
    stallApiResponseSuccess,
    stallApiResponseError,
} from "./actions";

function* getStallsFn({ payload }: any): any {
    try {
        const response = yield call(
            getStalls,
            payload?.vendorId
        );

        yield put(
            stallApiResponseSuccess(
                StallActionTypes.GET_STALLS,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            stallApiResponseError(
                StallActionTypes.GET_STALLS,
                error
            )
        );
    }
}

function* getStallByIdFn({ payload }: any): any {
    try {
        const response = yield call(getStallById, payload);
        yield put(
            stallApiResponseSuccess(
                StallActionTypes.GET_STALL_BY_ID,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            stallApiResponseError(
                StallActionTypes.GET_STALL_BY_ID,
                error
            )
        );
    }
}

function* addStallFn({ payload }: any): any {
    try {
        const response = yield call(createStall, payload);
        yield put(
            stallApiResponseSuccess(
                StallActionTypes.ADD_STALL,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            stallApiResponseError(
                StallActionTypes.ADD_STALL,
                error
            )
        );
    }
}

function* updateStallFn({ payload }: any): any {
    try {
        const { id, originalVendorId, ...body } = payload;

        const response = yield call(
            updateStall,
            id,
            originalVendorId,
            body
        );

        yield put(
            stallApiResponseSuccess(
                StallActionTypes.UPDATE_STALL,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            stallApiResponseError(
                StallActionTypes.UPDATE_STALL,
                error
            )
        );
    }
}

function* deleteStallFn({ payload }: any): any {
    try {
        const response = yield call(
            deleteStall,
            payload.vendorId,
            payload.stallId
        );
        yield put(
            stallApiResponseSuccess(
                StallActionTypes.DELETE_STALL,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            stallApiResponseError(
                StallActionTypes.DELETE_STALL,
                error
            )
        );
    }
}

export function* watchGetStalls() {
    yield takeEvery(StallActionTypes.GET_STALLS, getStallsFn);
}

export function* watchGetStallById() {
    yield takeEvery(StallActionTypes.GET_STALL_BY_ID, getStallByIdFn);
}

export function* watchAddStall() {
    yield takeEvery(StallActionTypes.ADD_STALL, addStallFn);
}

export function* watchUpdateStall() {
    yield takeEvery(StallActionTypes.UPDATE_STALL, updateStallFn);
}

export function* watchDeleteStall() {
    yield takeEvery(StallActionTypes.DELETE_STALL, deleteStallFn);
}

function* stallSaga() {
    yield all([
        fork(watchGetStalls),
        fork(watchGetStallById),
        fork(watchAddStall),
        fork(watchUpdateStall),
        fork(watchDeleteStall),
    ]);
}

export default stallSaga;